module.exports = __webpack_public_path__ + "static/6-2a14f663eda1620fd7d8714110acadb7.png";